// extracted by mini-css-extract-plugin
export default {"NavList__Container":"nav-items-module--NavList__Container--kJPea"};